import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { BarLoader } from 'react-spinners';
import SquareSector from './SquareSector';

class GridSector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      plate: this.props.plate || [],
    };

    // Give appetite's associated product's biz line
    for (let prods = this.props.products, i = 0, l = prods.length; i < l; i++) {
      const needle = prods[i].id;
      const biz = prods[i].businessLine;
      for (let apps = this.props.plate || [], i = 0, l = apps.length; i < l; i++) {
        if (apps[i].productId === needle) {
          apps[i].biz = biz;
        }
      }
    }
  }

  componentDidMount() {
    const tmp = this;
    setTimeout(() => {
      tmp.loadData();
    }, 2250);
  }

  loadData() {
    for (let prods = this.props.products, i = 0, l = prods.length; i < l; i++) {
      const needle = prods[i].id;
      const biz = prods[i].businessLine;
      for (let apps = this.props.plate, i = 0, l = apps.length; i < l; i++) {
        if (apps[i].productId === needle) {
          apps[i].biz = biz;
        }
      }
    }
    this.setState({
      plate: this.props.plate,
    });
  }

  render() {
    const { appetites } = this.props;
    const { plate } = this.state || {};
    const ln = appetites.length;

    return ln > 0 ? (
      <Fragment>
        <dl className="grid__list grid__list--sector">
          <dt className="grid__heading">P&amp;C</dt>
          {plate &&
            plate
              .sort((a, b) => {
                const initial = a.productName.toLowerCase();
                const next = b.productName.toLowerCase();
                if (initial < next) return -1;
                if (initial > next) return 1;
                return 0;
              })
              .map((square, i) => (
                <SquareSector
                  {...this.props}
                  square={square}
                  i={i}
                  key={i}
                  sector={this.sectorId}
                />
              ))
              .filter(square =>
                square.props.square.biz
                  .toString()
                  .toLowerCase()
                  .includes('property & casualty')
              )}
        </dl>
        <dl className="grid__list">
          <dt className="grid__heading">Financial Lines</dt>
          {plate &&
            plate
              .sort((a, b) => {
                const initial = a.productName.toLowerCase();
                const next = b.productName.toLowerCase();
                if (initial < next) return -1;
                if (initial > next) return 1;
                return 0;
              })
              .map((square, i) => (
                <SquareSector
                  {...this.props}
                  square={square}
                  i={i}
                  key={i}
                  sector={this.sectorId}
                />
              ))
              .filter(square =>
                square.props.square.biz
                  .toString()
                  .toLowerCase()
                  .includes('financial')
              )}
        </dl>
      </Fragment>
    ) : (
      <div className="spinner-holder">
        <BarLoader color="#150F96" />
      </div>
    );
  }
}

export default GridSector;



// WEBPACK FOOTER //
// ./src/components/GridSector.js